import {GameStatus, QuestionStatus} from "../constants"

const fetchQuestion = (state, action) => {
  // TODO: Fetch random elements/questions, rules might change later.

  console.log("fetchQuestion")

  const need = action.payload.need || 0;

  let notDispatched = state.filter((e) => {
    const available = e.questions[action.payload.round].find(
      (q) => q.status === QuestionStatus.AVAILABLE
    );

    if (available) {
      return e;
    }
    return null;
  });
  const fetchedElements = [];
  let fetchedQuestions = [];
  let retries = 0;
  const MAX_RETRIES = state.length * 3;

  
  if (fetchedQuestions.length < need && retries < MAX_RETRIES) {

    shuffleArray(notDispatched);
    for (let i = 0; i < notDispatched.length; i++) {
      const e = notDispatched[i];
      const availableQs = e.questions[action.payload.round].filter(
        (q) => q.status === QuestionStatus.AVAILABLE
      );
      if (availableQs.length > 0) {
        const available = availableQs[getRandom(0, availableQs.length - 1)];
        // if if not already in fetched
        if (fetchedQuestions.find((fq) => fq.id === available.id)) {
          continue;
        }

        const updatedQuestion = {
          ...available,
          status: QuestionStatus.DISPATCHED,
          dispatchedOn: new Date().getTime(),
        };
        if (fetchedQuestions.length < need) {
          fetchedQuestions.push(updatedQuestion);
          const newElement = { ...e };
          newElement.questions[action.payload.round] = newElement.questions[
            action.payload.round
          ].map((q) => {
            if (q.id === updatedQuestion.id) {
              return updatedQuestion;
            }
            return q;
          });
          fetchedElements.push(newElement);
        }
      } else {
        retries++;
      }
    }
  }

  if (fetchedQuestions.length > 0) {
    return state.map((el) => {
      const fetched = fetchedElements.find((e) => e.caption === el.caption);
      if (fetched) {
        return fetched;
      }
      return el;
    });
  }
  return state;
};

const setQuestionState = (state, action) => {
  return state.map((e) => {
    const newQuestions = e.questions[action.payload.round].map((q) => {
      const found = action.payload.questions.find((cq) => cq.id === q.id);
      if (found) {
        return {
          ...q,
          status: action.payload.status,
        };
      }
      return q;
    });
    const newElement = { ...e };
    newElement.questions[action.payload.round] = newQuestions;
    return newElement;
  });
};

const setElments = (state, action) => {
  return action.payload.elements.map((el) => {
    const managedFirstRound = el.questions[action.payload.gameStatus.round].map(
      (q) => {
        console.log("setElments q" , q);
        return {
          ...q,
          status: QuestionStatus.AVAILABLE,
          dispatchedOn: null,
          ttl: q.ttl || action.options.defaultQuestionTTL,
          value: q.value || action.options.defaultQuestionScoreValue,
        };
      }
    );
    const managedSecondRound = el.questions.secondRound.map((q) => {
      return {
        ...q,
        status: QuestionStatus.AVAILABLE,
        dispatchedOn: null,
        ttl: q.ttl || action.options.defaultQuestionTTL,
        value: q.value || action.options.defaultQuestionScoreValue,
      };
    });
    return {
      ...el,
      questions: {
        firstRound: managedFirstRound,
        secondRound: managedSecondRound,
      },
    };
  });
};

const missionElementsReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_QUESTION":
      return fetchQuestion(state, action);
    case "SET_QUESTION_STATUS":
      return setQuestionState(state, action);
    case "SET_ELEMENTS":
      return setElments(state, action);
    default:
  }
  return state;
};

function getRandom(min=0, max =0) {
    return Math.floor(Math.random() * (+max - +min)) + +min;
}

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
}

export default missionElementsReducer;
